import { render, staticRenderFns } from "./ModalButtonNav.vue?vue&type=template&id=47bb0029"
import script from "./ModalButtonNav.vue?vue&type=script&lang=js"
export * from "./ModalButtonNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports